module.exports = __webpack_public_path__ + "static/img/anzhidinglan_icon.505e0f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/anzhidinglan_icon.png
// module id = qLfO
// module chunks = 1